import(/* webpackMode: "eager", webpackExports: ["ProgrammesDirectory"] */ "/opt/build/repo/app/programmes/ProgrammesDirectory.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/client/components/shared/ErrorFallback.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/client/components/shared/hero/PageHero.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/client/components/shared/nav/Nav.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/client/components/shared/popup/AdmissionPopup.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/client/components/shared/ToastProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/client/components/shared/whatsapp-chat/WhatsApp-Chat.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ErrorBoundary"] */ "/opt/build/repo/node_modules/.pnpm/next@14.2.35_@playwright+test@1.62.1_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/client/components/error-boundary.js");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/.pnpm/next@14.2.35_@playwright+test@1.62.1_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/public/images/cert_in_diet_and_nutrition_therapy_in_cancer.png");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/public/images/Certificate_in_Healthy_Living.png");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/public/images/certificate_in_herbal_medicine_treatment_for_chronic_diseases.png");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/public/images/certificate_in_tcm_diagnosis.png");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/public/images/Certificate_in_Weight_Management.png");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/public/images/cet_in_herbal_med_protocol_for_autism.png");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/public/images/diploma_in_clinical_acupunture.png");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/public/images/Diploma_in_Naturopathy.png");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/public/images/Doctor_of_Medicine_in_Acupuncture.png");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/public/images/dr_of_naturopathic_medicine.png");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/public/images/dr_of_traditional_islamic_med.png");
